import './styles.scss';
import React, {Dispatch} from "react";

/* Types, Constants, Utils */
import * as Constants from "../../../../constants";
import Utils from "../../../../utils";

/* Bootstrap*/
import {ButtonGroup, Form} from "react-bootstrap";
import {FormCheckType} from "react-bootstrap/FormCheck";

/* React */
import {ISettings, IUserState} from "../../../../types/redux/user";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../../../redux";
import {AnyAction} from "@reduxjs/toolkit";
import {updateSettings} from "../../../../redux/slices/user-slice";

/* Components*/
import NotificationsSettings from "../../../../components/notification-settings";
import SortDropdown from "../../../../components/toolbars/components/sort-dropdown";
import ResultsPerPageDropdown from "../../../../components/toolbars/components/results-per-page-dropdown";

const SettingsGeneral = ():JSX.Element => {
  const settings: ISettings = useSelector<RootState, IUserState>(state => state.user).settings;
  const dispatch:Dispatch<AnyAction> = useDispatch();

  const handleRadio = (id:string, value: string): void => {
    const settingsCln: ISettings = {...settings};
    settingsCln[id] = value;
    dispatch(updateSettings(settingsCln))
  }

  const radioButton = (id: string, value: string, label: string): JSX.Element =>{
    return <Form.Check
      className={'radio mb-2 text-smaller'}
      key={'setting_' + id}
      type={Constants.RADIO as FormCheckType}
      id={id}
      checked={settings[id] === value}
      label={label}
      onChange={()=>handleRadio(id, value)}
    />
  }

  return (
    <div className={'settings-general content px-5 pt-4 pb-5 bg-white rounded-md'}>

      <h1 className={'mb-0 text-largest'}><strong>{Utils.toTitleCase(Constants.SETTINGS)}</strong></h1>
      <p className={'mt-2 mb-4'}>Customize your settings to match your preferences and enhance your experience for better efficiency</p>

      {/* Search start default */}
      <h2 className={'my-0 text-normal'} ><b>Default landing page</b></h2>
      <p className={'my-2 text-smaller'}>Choose which page you’d like to see first when you visit the site</p>

      <ButtonGroup aria-label={'Default landing page'} className={'sm mb-4 d-block  mt-2'}>
        {radioButton(Constants.LANDING, Constants.ABOUT, Utils.toTitleCase(Constants.ABOUT + ' ' + Constants.PAGE))}
        {radioButton(Constants.LANDING, Constants.DOCUMENTS, Utils.toTitleCase(Constants.DOCUMENTS + ' ' + Constants.PAGE))}
      </ButtonGroup>

      {/* Search start default */}
      <h2 className={'my-0 text-normal'} ><b>Default starting search</b></h2>
      <p className={'my-2 text-smaller'}>Choose between simple search or advanced search to have the same experience each time you log in</p>

      <ButtonGroup aria-label={'Default search'} className={'sm mb-4 d-block mt-2 '}>
        {radioButton(Constants.SEARCH, Constants.SIMPLE_SEARCH, Utils.toTitleCase(Constants.SIMPLE_SEARCH))}
        {radioButton(Constants.SEARCH, Constants.ADVANCED_SEARCH, Utils.toTitleCase(Constants.ADVANCED_SEARCH))}
      </ButtonGroup>

      {/* Search results default */}
      <h2 className={'mt-4 mb-0 text-normal'}><b>Default search results</b></h2>

      <div className={'mt-0 mb-4'}>
        <div className={'mt-2 mb-3 text-smaller'}>
          <span>Select whether to always display restricted documents, folders and potential duplicates in your sear results</span>
          {/*<Button className={'ms-2 btn-icon-only text-primary'}>
            <i className={'bi bi-info-circle'}/>
          </Button>*/}
        </div>
      </div>

      <p className={'mb-2'}>Select your preferred sorting criteria for search results</p>
      <SortDropdown context={Constants.SETTINGS}/>

      <p className={'mt-4 mb-2'}>Choose the number of rows displayed</p>
      <ResultsPerPageDropdown context={Constants.SETTINGS}/>

      {/* Notification Settings */}
      <NotificationsSettings/>

    </div>
  )
}

export default SettingsGeneral;
